import React from "react";
import classes from "./SectionHeading.module.css";
import Reveal from "../Reveal/Reveal";

/**
 * The landing page's section header.
 *
 * Replaces the `headerBorder` + `headerBox` pair that About, Impact,
 * VisionMission and WhyPuducherry each declared separately with slightly
 * different values.
 *
 * `align="center"` centres the block; `tone="light"` inverts it for use on the
 * navy panels.
 */
export default function SectionHeading({
  eyebrow,
  title,
  lead,
  align = "start",
  tone = "dark",
  id,
}) {
  return (
    <Reveal
      className={`${classes.heading} ${classes[align]} ${classes[tone]}`}
      selector="[data-line]"
      stagger={0.08}
      y={22}
    >
      {eyebrow && (
        <span className={classes.eyebrow} data-line>
          <span className={classes.rule} aria-hidden="true" />
          {eyebrow}
        </span>
      )}
      <h2 className={classes.title} data-line id={id}>
        {title}
      </h2>
      {lead && (
        <p className={classes.lead} data-line>
          {lead}
        </p>
      )}
    </Reveal>
  );
}
